<template>
  <v-container>
    <v-layout row v-if="error">
      <v-flex xs12 sm8 offset-sm2>
        <v-card class="elevation-8">
          <app-alert-error @dismissed="onDismiss" :text="error.message"></app-alert-error>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout row>
      <v-flex xs12 sm8 offset-sm2>
        <v-card class="mt-1 elevation-8">
          <v-toolbar dark color="farmer_green">
            <v-toolbar-title>Forgot Your Password</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form lazy-validation v-model="valid" @submit.prevent="onPasswordReset">
                <v-layout row wrap>
                  <v-flex xs12>
                    <p>
                      <strong>Enter your email address below,</strong>
                      <br>and we'll email you instructions on how to change your password.
                    </p>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      color="farmer_green"
                      prepend-icon="person"
                      name="email"
                      label="E-mail"
                      id="email"
                      type="email"
                      v-model="email"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs12>
                    <v-card flat>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="farmer_green"
                          dark
                          type="submit"
                          :disabled="loading"
                          :loading="loading"
                          @click="loader = 'loading'"
                        >Send</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    valid: true,
    email: ''
  }),
  computed: {
    user() {
      return this.$store.getters.user
    },
    error() {
      return this.$store.getters.error
    },
    loading() {
      return this.$store.getters.loading
    }
  },
  watch: {
    user(value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/')
      }
    }
  },

  methods: {
    onPasswordReset() {
      const resetObj = {
        email: this.email,
        redirect: '/email-sent'
      }
      this.$store.dispatch('resetUserPassword', resetObj)
    }
  }
}
</script>

<style scoped>
</style>
